import * as React from 'react';
import { motion, useInView } from 'framer-motion';

const AboutValues: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  
  const titleRef = React.useRef(null);
  const titleInView = useInView(titleRef, { once: true });
  
  const gridRef = React.useRef(null);
  const gridInView = useInView(gridRef, { once: true, amount: 0.2 });

  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const stagger = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.5
      }
    }
  };

  return (
    <motion.section 
      ref={ref}
      className="py-16 px-4 bg-zinc-100 "
      variants={stagger}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <div className="container mx-auto max-w-6xl">
        <motion.h2 
          ref={titleRef}
          className="text-3xl text-center text-gray-800 mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          Os Nossos Valores
        </motion.h2>
        
        <motion.div 
          ref={gridRef}
          className="grid md:grid-cols-3 gap-8"
          variants={stagger}
          initial="hidden"
          animate={gridInView ? "visible" : "hidden"}
        >
          <motion.div 
            className="text-center p-6 rounded-lg bg-gradient-to-b from-pink-50 to-white shadow-sm"
            variants={fadeInUp}
          >
            <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-pink-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Excelência</h3>
            <p className="text-gray-600">
              Compromisso com a qualidade superior em todos os serviços que prestamos.
            </p>
          </motion.div>

          <motion.div 
            className="text-center p-6 rounded-lg bg-gradient-to-b from-purple-50 to-white shadow-sm"
            variants={fadeInUp}
          >
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Cuidado</h3>
            <p className="text-gray-600">
              Cada cliente é único e merece um atendimento personalizado e carinhoso.
            </p>
          </motion.div>

          <motion.div 
            className="text-center p-6 rounded-lg bg-gradient-to-b from-blue-50 to-white shadow-sm"
            variants={fadeInUp}
          >
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">Inovação</h3>
            <p className="text-gray-600">
              Sempre atualizados com as últimas tendências e técnicas de beleza.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default AboutValues; 